// extracted by mini-css-extract-plugin
var _1 = "dashedline_horizontal__4agen";
var _2 = "dashedline_line__hektk";
export { _1 as "horizontal", _2 as "line" }
